import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

const KEY = "notifications";

export interface Notification {
	id: string;
	userId: string;
	type: string;
	title: string;
	body: string | null;
	data: Record<string, unknown> | null;
	isRead: boolean;
	readAt: string | null;
	createdAt: string;
}

export function useNotificationList() {
	return useQuery({
		queryKey: [KEY, "list"],
		queryFn: () =>
			api.get<{ items: Notification[]; total: number; unreadCount: number }>(
				"/api/notifications?limit=50",
			),
		refetchInterval: 15000,
	});
}

export function useMarkNotificationRead() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => api.patch<Notification>(`/api/notifications/${id}/read`, {}),
		onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, "list"] }),
	});
}
